enum Bool {
  TRUE = 'true',
  FALSE = 'false',
}

export default Bool;
